var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9605 21.2451C19.1746 20.4624 20.2226 19.4482 21.0447 18.2604C21.8669 17.0726 22.447 15.7346 22.752 14.3226C23.057 12.9106 23.0809 11.4524 22.8224 10.0312C22.5638 8.60998 22.0279 7.25361 21.2451 6.03952L17.9394 8.17081C18.4422 8.95077 18.7865 9.82215 18.9526 10.7352C19.1187 11.6482 19.1034 12.585 18.9074 13.4921C18.7115 14.3992 18.3388 15.2588 17.8106 16.0219C17.2824 16.7849 16.6092 17.4365 15.8292 17.9394L17.9605 21.2451Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27223 9.56794C0.802812 11.6385 0.942645 13.8007 1.67485 15.7936C2.40706 17.7865 3.70036 19.5249 5.39867 20.799C7.09698 22.0731 9.12773 22.8286 11.2459 22.9741C13.364 23.1197 15.479 22.6491 17.3356 21.6193L15.446 18.2125C14.2469 18.8776 12.8809 19.1815 11.513 19.0875C10.145 18.9935 8.83343 18.5056 7.7366 17.6827C6.63976 16.8599 5.8045 15.7371 5.33161 14.4501C4.85872 13.163 4.76841 11.7665 5.07157 10.4293L1.27223 9.56794Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0392 1.42818C12.886 0.809176 10.5951 0.86242 8.47295 1.58079C6.35083 2.29916 4.49865 3.6484 3.16418 5.44803C1.82971 7.24766 1.07658 9.41187 1.00553 11.6512C0.934484 13.8905 1.54891 16.0981 2.76661 17.9787L6.06747 15.8413C5.28508 14.633 4.89031 13.2146 4.93596 11.7759C4.98161 10.3371 5.4655 8.94658 6.32291 7.7903C7.18032 6.63403 8.37036 5.76713 9.73384 5.30557C11.0973 4.84401 12.5692 4.8098 13.9527 5.20752L15.0392 1.42818Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4382 6.35019C19.9398 3.84702 17.5083 2.04163 14.6788 1.33116L13.7212 5.14518C15.5392 5.60166 17.1014 6.76164 18.0641 8.36995L21.4382 6.35019Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.7dbf5d4b335a3f42ccd253f91cabab55.svg";
export { ForwardRef as ReactComponent };